import { createRouter, createWebHistory } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

const tokenName = import.meta.env.VITE_APP_TOKEN_NAME

const routes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'Dashboard', params: {} },
  },
  {
    name: 'Auth',
    path: '/auth',
    component: AuthLayout,
    redirect: { name: 'Login' },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/pages/auth/Login.vue'),
      },
    ],
  },
  {
    path: '/',
    component: AppLayout,
    redirect: { name: 'Dashboard' },
    children: [
      {
        name: 'Dashboard',
        path: 'dashboard',
        component: () => import('@/pages/dashboard/Dashboard.vue'),
      },
      {
        name: 'Settings',
        path: 'settings',
        component: () => import('@/pages/settings/Settings.vue'),
      },
      {
        name: 'Preferences',
        path: 'preferences',
        component: () => import('@/pages/preferences/Preferences.vue'),
      },
    ],
  },
  {
    name: 'User',
    path: '/user',
    component: AppLayout,
    children: [
      {
        name: 'SellerList',
        path: 'seller-list',
        component: () => import('@/pages/user/SellerList.vue'),
      },
      {
        name: 'SellerInfo',
        path: 'seller-info',
        component: () => import('@/pages/user/Sellerinfo.vue'),
      },
      {
        name: 'SellerDailyHistory',
        path: 'seller-daily-history',
        component: () => import('@/pages/user/SellerDailyHistory.vue'),
      },
      {
        name: 'BuyerList',
        path: 'buyer-list',
        component: () => import('@/pages/user/BuyerList.vue'),
      },
      {
        name: 'CorpDBList',
        path: 'corpdb-list',
        component: () => import('@/pages/user/CorpDBList.vue'),
      },
      {
        name: 'BuyerInfo',
        path: 'buyer-info',
        component: () => import('@/pages/user/BuyerInfo.vue'),
      },
      {
        name: 'CorpInfo',
        path: 'corp-info',
        component: () => import('@/pages/user/CorpInfo.vue'),
      },
    ],
  },
  {
    name: 'Product',
    path: '/product',
    component: AppLayout,
    children: [
      {
        name: 'MarketPriceList',
        path: 'market-price-list',
        component: () => import('@/pages/product/MarketPriceList.vue'),
      },
      {
        name: 'MarketPriceInfo',
        path: 'market-price-info',
        component: () => import('@/pages/product/MarketPriceInfo.vue'),
      },
      {
        name: 'SpecialPriceList',
        path: 'special-price-list',
        component: () => import('@/pages/product/SpecialPriceList.vue'),
      },
      {
        name: 'SpecialPriceInfo',
        path: 'special-price-info',
        component: () => import('@/pages/product/SpecialPriceInfo.vue'),
      },
      {
        name: 'ReportList',
        path: 'report-list',
        component: () => import('@/pages/product/ReportList.vue'),
      },
      {
        name: 'ReportDailyList',
        path: 'report-daily-list',
        component: () => import('@/pages/product/ReportDailyList.vue'),
      },
      {
        name: 'ReportInfo',
        path: 'report-info/:id',
        component: () => import('@/pages/product/ReportInfo.vue'),
      },
      {
        name: 'ScrapList',
        path: 'scrap-list',
        component: () => import('@/pages/product/ScrapList.vue'),
      },
      {
        name: 'ScrapChart',
        path: 'scrap-chart',
        component: () => import('@/pages/product/ScrapChart.vue'),
      },
    ],
  },
  {
    name: 'Payment',
    path: '/payment',
    component: AppLayout,
    children: [
      {
        name: 'PaymentItemList',
        path: 'item',
        component: () => import('@/pages/payment/PaymentItemList.vue'),
      },
      {
        name: 'PaymentBannerList',
        path: 'banner',
        component: () => import('@/pages/payment/PaymentBannerList.vue'),
      },
      {
        name: 'PaymentEntryList',
        path: 'entry',
        component: () => import('@/pages/payment/PaymentEntryList.vue'),
      },
    ],
  },
  {
    name: 'Admin',
    path: '/admin',
    component: AppLayout,
    children: [
      {
        name: 'AdminList',
        path: 'admin-list',
        component: () => import('@/pages/admin/AdminList.vue'),
      },
      {
        name: 'AdminDetail',
        path: 'admin-detail/:id',
        component: () => import('@/pages/admin/AdminDetail.vue'),
      },
      {
        name: 'AdminCreate',
        path: 'admin-create',
        component: () => import('@/pages/admin/AdminCreate.vue'),
      },
      {
        name: 'GroupAuthority',
        path: 'group-authority',
        component: () => import('@/pages/admin/GroupAuthority.vue'),
      },
      {
        name: 'MenuAuthority',
        path: 'menu-authority',
        component: () => import('@/pages/admin/MenuAuthority.vue'),
      },
      {
        name: 'Log',
        path: 'log',
        component: () => import('@/pages/admin/Log.vue'),
      },
      {
        name: 'AppPauseList',
        path: 'app-pause-list',
        component: () => import('@/pages/admin/AppPauseList.vue'),
      },
      {
        name: 'AppPauseDetail',
        path: 'app-pause-detail/:id',
        component: () => import('@/pages/admin/AppPauseDetail.vue'),
      },
      {
        name: 'AppPauseCreate',
        path: 'app-pause-create/create',
        component: () => import('@/pages/admin/AppPauseCreate.vue'),
      }
    ],
  },
  // Support는 list, create, edit 등 세부 페이지가 많기에 children 구조로 수정.
  {
    name: 'Support',
    path: '/support',
    component: AppLayout,
    children: [
      {
        name: 'Banner',
        path: 'banner',
        children: [
          {
            name: 'SupportBannerList',
            path: 'seller/list',
            component: () => import('@/pages/support/banner/BannerList.vue'),
          },
          {
            name: 'SupportBannerDetail',
            path: 'seller/detail/:id',
            component: () => import('@/pages/support/banner/BannerDetail.vue'),
          },
          {
            name: 'SupportBannerBuyerList',
            path: 'buyer/list',
            component: () => import('@/pages/support/banner/BannerBuyerList.vue'),
          },
          {
            name: 'SupportBannerBuyerDetail',
            path: 'buyer/detail/:id',
            component: () => import('@/pages/support/banner/BannerBuyerDetail.vue'),
          },
          {
            name: 'SupportBannerBuyerCreate',
            path: 'buyer/create',
            component: () => import('@/pages/support/banner/BannerBuyerCreate.vue'),
          },
          {
            name: 'SupportBannerProductList',
            path: 'product/list',
            component: () => import('@/pages/support/banner/BannerProductList.vue'),
          },
        ],
      },
      {
        name: 'Item',
        path: 'item',
        children: [
          {
            name: 'SupportItemList',
            path: 'list',
            component: () => import('@/pages/support/item/ItemList.vue'),
          },
          {
            name: 'SupportItemProductList',
            path: 'list',
            component: () => import('@/pages/support/item/ItemProductList.vue'),
          },
        ],
      },
      {
        name: 'Event',
        path: 'event',
        children: [
          {
            name: 'SupportEventList',
            path: 'list',
            component: () => import('@/pages/support/event/EventList.vue'),
          },
          {
            name: 'SupportEventDetail',
            path: 'detail/:id',
            component: () => import('@/pages/support/event/EventDetail.vue'),
          },
          {
            name: 'SupportEventCreate',
            path: 'create',
            component: () => import('@/pages/support/event/EventCreate.vue'),
          },
          {
            name: 'SupportEventWinnerList',
            path: 'winner/list',
            component: () => import('@/pages/support/event/EventWinnerList.vue'),
          },
        ],
      },
      {
        name: 'Winner',
        path: 'winner',
        children: [
          {
            name: 'SupportWinnerList',
            path: 'list',
            component: () => import('@/pages/support/winner/WinnerList.vue'),
          },
        ],
      },
      {
        name: 'Notice',
        path: 'notice',
        children: [
          {
            name: 'SupportNoticeList',
            path: 'list',
            component: () => import('@/pages/support/notice/NoticeList.vue'),
          },
          {
            name: 'SupportNoticeDetail',
            path: 'detail/:id',
            component: () => import('@/pages/support/notice/NoticeDetail.vue'),
          },
          {
            name: 'SupportNoticeCreate',
            path: 'create',
            component: () => import('@/pages/support/notice/NoticeCreate.vue'),
          },
        ],
      },
      {
        name: 'FAQ',
        path: 'faq',
        children: [
          {
            name: 'SupportFAQList',
            path: 'list',
            component: () => import('@/pages/support/faq/FAQList.vue'),
          },
          {
            name: 'SupportFAQDetail',
            path: 'detail/:id',
            component: () => import('@/pages/support/faq/FAQDetail.vue'),
          },
          {
            name: 'SupportFAQCreate',
            path: 'create',
            component: () => import('@/pages/support/faq/FAQCreate.vue'),
          },
        ],
      },
      {
        name: 'Contact',
        path: 'contact',
        children: [
          {
            name: 'SupportContactList',
            path: 'list',
            component: () => import('@/pages/support/contact/contactList.vue'),
          },
          {
            name: 'SupportContactDetail',
            path: 'detail/:id',
            component: () => import('@/pages/support/contact/contactDetail.vue'),
          },
        ],
      },
      {
        name: 'CorpWait',
        path: 'corp-wait',
        children: [
          {
            name: 'SupportCorpWaitList',
            path: 'list',
            component: () => import('@/pages/support/corp-wait/CorpWaitList.vue'),
          },
          {
            name: 'SupportCorpWaitDetail',
            path: 'detail/:id',
            component: () => import('@/pages/support/corp-wait/CorpWaitDetail.vue'),
          },
        ],
      },
      {
        name: 'Inquiry',
        path: 'inquiry',
        children: [
          {
            name: 'SupportInquiryList',
            path: 'list',
            component: () => import('@/pages/support/inquiry/InquiryList.vue'),
          },
          {
            name: 'SupportInquiryDetail',
            path: 'detail/:id',
            component: () => import('@/pages/support/inquiry/InquiryDetail.vue'),
          },
        ],
      },
      {
        name: 'Edu',
        path: 'edu',
        children: [
          {
            name: 'SupportEduList',
            path: 'list',
            component: () => import('@/pages/support/inquiry/EduList.vue'),
          },
          {
            name: 'SupportEduDetail',
            path: 'detail/:id',
            component: () => import('@/pages/support/inquiry/EduDetail.vue'),
          },
        ],
      },
    ],
  },
  {
    name: 'Statistics',
    path: '/statistics',
    component: AppLayout,
    children: [
      {
        name: 'StatisticsSignup',
        path: 'signup',
        component: () => import('@/pages/statistics/Signup.vue'),
      },
      //결제통계
      {
        name: 'StatisticsPayment',
        path: 'payment',
        component: () => import('@/pages/statistics/Payment.vue'),
      },
      //판매전화통계
      {
        name: 'Top10Bizcall',
        path: 'top10-biz-call',
        component: () => import('@/pages/statistics/Top10Bizcall.vue'),
      },
      //수거지역, 항목 등 주요정보 top10
      {
        name: 'Top10PrimaryInfo',
        path: 'top10-primary-info',
        component: () => import('@/pages/statistics/Top10PrimaryInfo.vue'),
      },
      //Top10tradeArea 지역기반 정렬
      {
        name: 'Top10tradeArea',
        path: 'top10-trade-area',
        component: () => import('@/pages/statistics/Top10tradeArea.vue'),
      },
      //Top10tradeArea 고물기준 정렬
      {
        name: 'Top10tradeScraps',
        path: 'top10-trade-scraps',
        component: () => import('@/pages/statistics/Top10tradeScraps.vue'),
      },
      /*{
        name: 'Top10SellerAlert',
        path: 'top10-seller-alert',
        component: () => import('@/pages/statistics/Top10SellerAlert.vue'),
      },*/

      //매입자지역통계
      {
        name: 'Top10BuyerRegion',
        path: 'top10-buyer-region',
        component: () => import('@/pages/statistics/Top10BuyerRegion.vue'),
      },
      //매입자고물통계
      {
        name: 'Top10BuyerScrap',
        path: 'top10-buyer-scrap',
        component: () => import('@/pages/statistics/Top10BuyerScrap.vue'),
      },
      //매입자고물통계
      {
        name: 'Top10BuyerAlert',
        path: 'top10-buyer-alert',
        component: () => import('@/pages/statistics/Top10BuyerAlert.vue'),
      },
      {
        name: 'StatisticsPickupMethod',
        path: 'pickup-method',
        component: () => import('@/pages/statistics/PickupMethod.vue'),
      },
      {
        name: 'StatisticsPickupRegion',
        path: 'pickup-region',
        component: () => import('@/pages/statistics/PickupRegion.vue'),
      },
      {
        name: 'StatisticsPickupScrap',
        path: 'pickup-scrap',
        component: () => import('@/pages/statistics/PickupScrap.vue'),
      },
      {
        name: 'StatisticsSellerAlert',
        path: 'seller-alert',
        component: () => import('@/pages/statistics/SellerAlert.vue'),
      },
      {
        name: 'StatisticsBuyerRegion',
        path: 'buyer-region-at',
        component: () => import('@/pages/statistics/BuyerRegion.vue'),
      },
      {
        name: 'StatisticsBuyerScrap',
        path: 'buyer-scrap',
        component: () => import('@/pages/statistics/BuyerScrap.vue'),
      },
      {
        name: 'StatisticsBuyerAlert',
        path: 'buyer-alert',
        component: () => import('@/pages/statistics/BuyerAlert.vue'),
      },
    ],
  },
  {
    name: 'Notification',
    path: '/notification',
    component: AppLayout,
    children: [
      {
        name: 'NotificationUser',
        path: 'list-user',
        component: () => import('@/pages/notification/AlarmListUser.vue'),
      },
      {
        name: 'NotificationSystem',
        path: 'list-system',
        component: () => import('@/pages/notification/AlarmListSystem.vue'),
      },
      {
        name: 'NotificationSeller',
        path: 'seller',
        component: () => import('@/pages/notification/Seller.vue'),
      },
      {
        name: 'NotificationBuyer',
        path: 'buyer',
        component: () => import('@/pages/notification/Buyer.vue'),
      },
      {
        name: 'NotificationAuto',
        path: 'auto',
        component: () => import('@/pages/notification/Auto.vue'),
      },
      {
        name: 'NotificationAdmin',
        path: 'admin',
        component: () => import('@/pages/push/PushList.vue'),
      },
    ],
  },
  {
    name: 'Terms',
    path: '/terms',
    component: AppLayout,
    children: [
      {
        name: 'TermsList',
        path: 'term',
        component: () => import('@/pages/terms/TermsList.vue'),
      },
      {
        name: 'TermsHistoryList',
        path: 'history',
        component: () => import('@/pages/terms/TermsHistoryList.vue'),
      },
      {
        name: 'TermsDetail',
        path: 'term/:id',
        component: () => import('@/pages/terms/TermsDetail.vue'),
      },
      {
        name: 'TermsCreate',
        path: 'create',
        component: () => import('@/pages/terms/TermsCreate.vue'),
      },
    ],
  },
  {
    name: 'Push',
    path: '/push',
    component: AppLayout,
    children: [
      {
        name: 'PushList',
        path: 'list',
        component: () => import('@/pages/push/PushList.vue'),
      },
    ],
  },
  {
    name: 'Regmsg',
    path: '/regmsg',
    component: AppLayout,
    children: [
      {
        name: 'RegmsgList',
        path: 'list',
        component: () => import('@/pages/registered-msg/List.vue'),
      },
      {
        name: 'RegmsgDetail',
        path: 'detail/:id',
        component: () => import('@/pages/registered-msg/Detail.vue'),
      },
      {
        name: 'RegmsgCreate',
        path: 'create',
        component: () => import('@/pages/registered-msg/Create.vue'),
      },
    ],
  },
  //     {
  //       path: 'terms',
  //       redirect: 'terms/terms-list-ko',
  //       children: [
  //         { name: 'terms-list-ko', path: 'terms-list-ko', meta: { lang: 'ko' }, component: () => import('@/pages/terms/TermsEdit.vue') },
  //         { name: 'terms-list-en', path: 'terms-list-en', meta: { lang: 'en' }, component: () => import('@/pages/terms/TermsEdit.vue') }
  //       ]
  //     },
  //     {
  //       path: 'banner',
  //       redirect: 'banner/banner-list-ko',
  //       children: [
  //         { name: 'banner-list-ko', path: 'banner-list-ko', meta: { lang: 'ko' }, component: () => import('@/pages/banner/BannerPage.vue') },
  //         { name: 'banner-create-ko', path: 'banner-create-ko', meta: { lang: 'ko' }, component: () => import('@/pages/banner/BannerCreate.vue') },
  //         { name: 'banner-edit-ko', path: 'banner-edit-ko/:id', meta: { lang: 'ko' }, component: () => import('@/pages/banner/BannerEdit.vue') },
  //         { name: 'banner-list-en', path: 'banner-list-en', meta: { lang: 'en' }, component: () => import('@/pages/banner/BannerPage.vue') },
  //         { name: 'banner-create-en', path: 'banner-create-en', meta: { lang: 'en' }, component: () => import('@/pages/banner/BannerCreate.vue') },
  //         { name: 'banner-edit-en', path: 'banner-edit-en/:id', meta: { lang: 'en' }, component: () => import('@/pages/banner/BannerEdit.vue') }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   path: '/auth',
  //   component: AuthLayout,
  //   children: [
  //     {
  //       name: 'login',
  //       path: 'login',
  //       component: () => import('@/pages/auth/Login.vue'),
  //     },
  //     {
  //       path: '',
  //       redirect: { name: 'login' },
  //     }
  //   ]
  // },
  // {
  //   name: '404',
  //   path: '/404',
  //   component: () => import('@/pages/404.vue'),
  // }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  const authUrl = '/auth/login'
  const token = localStorage.getItem(tokenName)

  if (to.path === authUrl) {
    next()
  } else if (!token) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
